<!--
 * @Description: 代缴税金新增弹窗
 * @Date: 2026-03-26 11:27:40
-->

<template>
  <BaseDialog
    width="500px"
    title="新增代缴税金"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :showFooter="false"
  >
    <BaseTextContent>
      <BaseForm
        ref="formRef"
        label-position="right"
        :rules="formRules"
        :model="formData"
      >
        <BaseFormItem label="选择园区" prop="businessParkId">
          <BaseSelect
            placeholder="请选择"
            clearable
            filterUseRemote
            valueKey="id"
            labelKey="businessParkName"
            :remoteMethod="yqRemoteMethod"
            v-model="formData.businessParkId"
            @change="onChangePark"
          ></BaseSelect>
        </BaseFormItem>
        <BaseFormItem label="申报方式" prop="declareMethod">
          <BaseRadioGroup disabled v-model="formData.declareMethod">
            <BaseRadio
              v-for="item in DECLARE_METHOD"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </BaseRadio>
          </BaseRadioGroup>
        </BaseFormItem>
        <BaseFormItem label="所属月份" prop="incomeMonthEnd">
          <BaseDatePicker
            type="monthrange"
            range-separator="至"
            value-format="YYYY-MM"
            :start-placeholder="'起'"
            :end-placeholder="'止'"
            v-model="incomeMonth"
            @change="onChangeMonth"
          ></BaseDatePicker>
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="remove">取消</BaseButton>
      <BaseButton type="primary" @click="onConfirm">确认</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseTextContent,
  BaseForm,
  BaseFormItem,
  BaseDialog,
  BaseButton,
  XrkMessage,
  BaseSelect,
  BaseRadioGroup,
  BaseRadio,
  BaseDatePicker
} from 'xrk-components';
import { listPark, addProxyTax } from '../../data-source/apis';
import { DECLARE_METHOD } from '../../constants';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

const emits = defineEmits(['success']);

const props = withDefaults(
  defineProps<{
    remove?: () => {};
  }>(),
  {}
);

const { info } = storeToRefs(appStore.useUserStoreSetup);

const incomeMonth = ref([]);
const formData = ref({
  businessParkId: null,
  declareMethod: null, // 由园区赋值，不可修改
  incomeMonthStart: null,
  incomeMonthEnd: null
});

const formRules = {
  businessParkId: [
    {
      required: true,
      trigger: 'change',
      message: '请选择'
    }
  ],
  declareMethod: [
    {
      required: true,
      trigger: 'change',
      message: '请选择'
    }
  ],
  incomeMonthEnd: [
    {
      required: true,
      trigger: 'change',
      message: '请选择'
    }
  ]
};

const yqRemoteMethod = async (name?: string) => {
  return listPark({ name, enable: 1, proxyId: info.value.finalDepId });
};

const onChangePark = (val, [option]) => {
  formData.value.declareMethod = option.declareMethod;
};
const onChangeMonth = val => {
  formData.value.incomeMonthStart = val?.[0] || '';
  formData.value.incomeMonthEnd = val?.[1] || '';
};
const onConfirm = async () => {
  await addProxyTax(formData.value);
  XrkMessage.success('操作成功');
  emits('success');
  props.remove?.();
};
</script>
